import { useStore } from "vuex"

export default {
    name: "HoldRedigerKvittering",
    setup(){
        const store = useStore()
        
        return {
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'HoldRedigerKvittering',
                    labelKey
                })
        }
    }
}